// R1-04B: PDF/CSV download helpers shared between the Custom Report Builder dialog and its
// standalone "Open in New Tab" print view, so both stay in sync with zero duplicated logic.
import api from "@/lib/api";

// Prefers the server's own Content-Disposition filename (section-named for a single-section
// CSV, etc.) and only falls back to a generic name if the header is missing.
export const filenameFromHeaders = (headers, fallback) => {
  const m = /filename="?([^";]+)"?/i.exec(headers["content-disposition"] || "");
  return m ? m[1] : fallback;
};

export const blobErrorMessage = async (blob, fallback) => {
  try { return (JSON.parse(await blob.text())).detail || fallback; } catch { return fallback; }
};

export const triggerDownload = (blob, filename) => {
  const u = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = u; a.download = filename; a.click();
  URL.revokeObjectURL(u);
};

// Both return null on success, or a user-facing error message string on failure.
export async function downloadCustomReportPdf(params, range) {
  try {
    const r = await api.get("/reports/custom/pdf", { params, responseType: "blob" });
    triggerDownload(r.data, filenameFromHeaders(r.headers, `Custom-Report-${range.start}_to_${range.end}.pdf`));
    return null;
  } catch (e) {
    return e?.response?.data ? await blobErrorMessage(e.response.data, "Could not build the PDF — please try again") : "Could not build the PDF — please try again";
  }
}

export async function downloadCustomReportCsv(params, range) {
  try {
    const r = await api.get("/reports/custom/csv", { params, responseType: "blob" });
    const isZip = (r.headers["content-type"] || "").includes("zip");
    triggerDownload(r.data, filenameFromHeaders(r.headers, `Custom-Report-${range.start}_to_${range.end}.${isZip ? "zip" : "csv"}`));
    return null;
  } catch (e) {
    return e?.response?.data ? await blobErrorMessage(e.response.data, "Could not export CSV — please try again") : "Could not export CSV — please try again";
  }
}
